import React, { Component } from 'react'

import classes from './Hat.css'
import HatNav from './hatNav/hatNav'
class Hat extends Component {
    render() {
        return (

            <div className={classes.Hat}>
                <div className={classes.title}>
                    <p className={classes.headerP}>
                        Солнечная Аэрокосмическая энергетическая система
                    </p>
                    <p className={classes.akes}>
                        АКЭС
                        </p>

                </div>
                <HatNav />
            </div>





        )

    }

}
export default Hat


// WEBPACK FOOTER //
// ./src/containers/Hat/Hat.js